import { $, $$ } from 'utils/dom';

const locationMap = $('.location-map');

if (locationMap) {
  const mapButtons = $$('[data-js=location-map-button]', locationMap);
  const modals = $$('[data-js=location-map-modal]', locationMap);
  const closeButtons = $$('[data-js=location-map-modal-close]', locationMap);

  mapButtons.forEach(button => {
    button.addEventListener('click', () => {
      modals.forEach(modal => {
        if (modal.getAttribute('data-id') === button.getAttribute('data-id')) {
          modal.classList.toggle('is-active');
        }
      });
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      modals.forEach(modal => {
        if (modal.classList.contains('is-active')) {
          modal.classList.remove('is-active');
        }
      });
    });
  });
}
